import React from 'react';

const TrustBar: React.FC = () => {
  const badges = [
    { icon: '🏢', text: 'Enterprise-Grade Security' },
    { icon: '🌍', text: 'Global Scale' },
    { icon: '✓', text: 'GDPR Compliant' },
  ];

  return (
    <div className="bg-white py-8 shadow-lg">
      <div className="max-w-7xl mx-auto px-8">
        <p className="text-gray-600 text-sm text-center mb-4 uppercase tracking-wide font-semibold">
          Trusted by Organizations Worldwide
        </p>
        <div className="flex flex-wrap justify-center gap-8 items-center">
          {badges.map((badge, index) => (
            <div key={index} className="text-soez-blue font-semibold text-base flex items-center gap-2">
              <span>{badge.icon}</span>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;
